<template>
  <div>
    <div class="vx-card p-6">
      <form class="p-6 mb-5 card-bg" @submit.prevent="getPurchaseList()">
        <h1 class="p-6 text-center mb-5">Satın Alma Yönetimi</h1>

        <div id="satis-islemleri " class="">
          <div class="id-inputs vx-row">
            <div class="vx-col islem-id mb-4 md:w-1/4 w-full">
              <label class="text-sm"><b>Satın Alma Id</b></label>
              <vs-input type="number" size="large" class="w-full" v-model="searchModel.purchaseId" />
            </div>
            <div class="vx-col urun-id mb-4 md:w-1/4 w-full">
              <div class="vx-row">
                <div class="vx-col md:w-2/3 w-full">
                  <label class="text-sm"><b>Ürün Id</b></label>
                  <vs-input type="number" class="w-full" size="large" v-model="searchModel.productId" />
                </div>
                <div class="vx-col mt-5">
                  <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                  <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
                </div>
              </div>
            </div>

            <div class="vx-col musteri-id mb-4 md:w-1/4 w-full">
              <label class="text-sm"><b>Tedarikçi Id</b></label>
              <vs-input type="number" size="large" class="w-full" v-model="searchModel.supplierId" />
            </div>
            <div class="vx-col md:w-1/5 w-full mt-5">
              <b><vs-checkbox v-model="searchModel.isActiveForStock" @input="getPurchaseList()">Stok Bekleyen</vs-checkbox></b>
            </div>
          </div>
          <div class="satis-inputs vx-row mb-4">
            <div class="satis-baslangic vx-col mb-4 md:w-1/4 w-full">
              <label class="text-sm"><b>Başlangıç</b></label>
              <vs-input type="date" size="medium" class="w-full" v-model="searchModel.startDate" />
            </div>
            <div class="satis-bitis mb-4 vx-col md:w-1/4 w-full">
              <label class="text-sm"><b>Bitiş</b></label>
              <vs-input @change="getPurchaseList()" type="date" size="medium" class="w-full" v-model="searchModel.finishDate" />
            </div>
            <div class="satis-yapan mb-4 vx-col md:w-1/4 w-full">
              <label class="text-sm"><b>Satın Alma Yapan</b></label>
              <v-select @input="getPurchaseList()" placeholder="Üretim Yapan" label="userName" :options="personnelList" v-model="searchModel.userId" :reduce="(row) => row.userId">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
            <div class="satis-durum mb-4 vx-col md:w-1/4 w-full">
              <label class="text-sm"><b>Durum</b></label>
              <v-select @input="getPurchaseList()" placeholder="Durum" label="statusDescription" :options="statusList" v-model="searchModel.statusName" :reduce="(row) => row.statusName">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
          </div>

          <div class="satis-buton w-full tFlex tFlex_column tFlex_ai-c">
            <vs-button class="vx-col md:w-1/4 w-full mb-4" style="">Ara</vs-button>
          </div>
        </div>
      </form>

      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex flex-grow justify-between align-center card-bg">
          <div class="drpodown mr-2">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2"
                  >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
                  -
                  {{ purchaseList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : purchaseList.length }}
                  of {{ purchaseList.length }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                  <span>30</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        </div>
      </div>

      <!-- prompt for addnew personnel -->

      <!-- AgGrid Table -->

      <div class="card-bg ag-grid-between">
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="purchaseList"
          rowSelection="single"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :rowClassRules="rowClassRules"
          :context="context"
        ></ag-grid-vue>
      </div>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import ProductSearch from "../../Search/ProductSearch.vue";
import vSelect from "vue-select";

// Cell Renderer
import CellRendererLink from "./purchaseListCellRenderer/CellRendererLink.vue";
import CellRendererPurchaseDetailListToString from "./purchaseListCellRenderer/CellRendererPurchaseDetailListToString.vue";
import CellRendererExpenseListToString from "./purchaseListCellRenderer/CellRendererExpenseListToString.vue";
import CellRendererStatus from "./purchaseListCellRenderer/CellRendererStatus.vue";
import CellRendererActions from "./purchaseListCellRenderer/CellRendererActions.vue";
import CellRendererTags from "./purchaseListCellRenderer/CellRendererTags.vue";

export default {
  components: {
    AgGridVue,
    CellRendererPurchaseDetailListToString,
    CellRendererExpenseListToString,
    CellRendererLink,
    CellRendererStatus,
    CellRendererActions,
    CellRendererTags,
    ProductSearch,
    vSelect,
  },
  data() {
    return {
      statusList: [
        { statusName: "T", statusDescription: "Talep" },
        { statusName: "O", statusDescription: "Onay" },
      ],
      productSearchPopupParent: false,
      personnelList: [],
      searchModel: {},
      searchQuery: "",
      context: null,
      delayedSearchTimer: "",
      purchaseList: [],
      ShowCustomerData: [],
      gridApi: null,
      rowClassRules: null,

      gridOptions: { rowHeight: 145 },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Talep Id",
          field: "purchaseId",
          filter: true,
          headerCheckboxSelectionFilteredOnly: true,
          width: 90,
        },

        {
          headerName: "Personel",
          field: "purchaseUserName",
          filter: true,
          width: 140,
        },

        {
          headerName: "Açıklama",
          field: "purchaseDetail",
          filter: true,
          width: 450,

          cellRendererFramework: "CellRendererPurchaseDetailListToString",
        },

        {
          headerName: "Maliyet Harcamaları",
          field: "transactions",
          filter: true,
          width: 240,
          heigth: 300,
          cellRendererFramework: "CellRendererExpenseListToString",
        },

        {
          headerName: "Tarih",
          field: "date",
          sort: "desc",
          filter: true,
          width: 150,
        },

        {
          headerName: "Durum",
          field: "statusDescription",
          filter: true,
          width: 150,
        },

        {
          headerName: "İşlem",
          field: "transactions",
          width: 200,
          cellRendererFramework: "CellRendererActions",
        },
      ] /* eslint-enable  */,
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.searchModel.productId = v.productId;
      } else {
        this.searchModel.productId = null;
      }
    },
    getPurchaseList: async function () {
      await this.$vs.loading();
      let list = await repository.postEntity("Purchase/getPurchaseList", this.searchModel).then((r) => r.list);
      await this.$vs.loading.close();
      if (list) this.purchaseList = list;
      else {
        this.$vs.notify({
          title: "Liste Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
      this.loading = false;
    },

    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if ((this.searchQuery && this.searchQuery.length > 3) || this.searchQuery == "") this.search();
      }, 500);
    },
    search: async function () {
      let r = await repository.getWithParam("Customer/search", "searchQuery=" + this.searchQuery + "&currentPage=0&pageSize=100");

      if (r && r.isSuccessful) {
        this.ShowCustomerData = r.list;
      } else this.ShowCustomerData = this.purchaseList;
    },
    getUsers: async function () {
      this.personnelList = await repository.postEntity("HumanResource/GetUser", { status: 1 }).then((r) => r.list);
    },
  },
  beforeMount() {
    this.rowClassRules = {};
    this.context = { componentParent: this };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
  created: async function () {
    await Promise.all([this.getPurchaseList(), this.getUsers()]);
  },
};
</script>

<style lang="scss" scoped></style>
